"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-plusplus */
/* eslint-disable prettier/prettier */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-param-reassign */
const react_1 = __importDefault(require("react"));
const link_1 = __importDefault(require("next/link"));
const prop_types_1 = __importDefault(require("prop-types"));
const next_components_tag_link_1 = __importDefault(require("@gerenciatd/next.components.tag-link"));
const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
const appendHost = (href) => {
    if (href.indexOf('http') === -1 && href.indexOf('//') === -1) {
        switch (currentEnv) {
            case 'dev':
                href = `127.0.0.1:8089${href}`;
                break;
            case 'prod':
                href = `https://www.movistar.es${href}`;
                break;
            case 'qa':
                href = `https://qa.cms.col.movistar.es${href}`;
                break;
        }
    }
    return href;
};
const getReadyLinkForDev = (href) => {
    // eliminamos el basename del proyecto
    let devLink = href.replace(`${process.env.NEXT_PUBLIC_PROJECT_BASE_PATH}`, '');
    if (!devLink) {
        devLink = "/";
    }
    return devLink;
};
const hasDynamicPathTokken = (pathTokken) => pathTokken.indexOf('[') > -1 && pathTokken.indexOf(']') > -1;
const checkIfHasHrefOperators = (href) => {
    let result = false;
    const OPERATORS = ['tel:', 'mailto:'];
    OPERATORS.forEach(item => {
        if (!result && href.indexOf(item) > -1) {
            result = true;
        }
    });
    return result;
};
const checkIfHrefCouldBeInternal = (href, forceExternal) => {
    let internal = false;
    if (!forceExternal && href.indexOf('http') === -1 && href.indexOf('//') === -1) {
        if (checkIfHasHrefOperators(href)) {
            internal = true;
        }
        if (!internal) {
            // ADAPTAMOS PARA PODER COMPARAR BEGINS //
            // 0) limpiar parametros get y hash para evaluar si es interna
            href = href.split('?')[0];
            href = href.split('#')[0];
            // 0.1) si la url tiene host esta claro que no es interna
            if (href[href.length - 1] !== '/') {
                href = `${href}/`;
            }
            // le quito el host si me llega con el para poder comparar
            try {
                const auxUrl = new URL(href);
                if (auxUrl && auxUrl.origin) {
                    href = href.replace(auxUrl.origin, '');
                }
            }
            catch (err) {
                // La url: ${href} es relativa por lo que casi es interna`
            }
            // ADAPTAMOS PARA PODER COMPARAR ENDS //
            const projectUrls = JSON.parse(`${process.env.NEXT_PUBLIC_PROJECT_URLS}`);
            projectUrls.forEach((link) => {
                if (!internal) {
                    // 1) primero comprobar si encaja al 100%
                    if (link === href) {
                        internal = true;
                    }
                    // 2) comprobar si alguna pposicion tiene [], y es dinamico
                    if (!internal) {
                        if (hasDynamicPathTokken(link)) {
                            // 2.1) troceamos para ver si cumple por patrones
                            const hrefTokkens = href.split('/').filter((tokken) => tokken !== "");
                            const linkTokkens = link.split('/').filter((tokken) => tokken !== "");
                            const sameLength = hrefTokkens.length === linkTokkens.length;
                            const cmpResults = {
                                'true': 0,
                                'false': 0,
                            };
                            if (sameLength) {
                                for (let t = 0; t < linkTokkens.length; t += 1) {
                                    const currentResult = hrefTokkens[t] === linkTokkens[t] ||
                                        hasDynamicPathTokken(linkTokkens[t]);
                                    const booleanIndex = `${currentResult}`;
                                    cmpResults[booleanIndex] += 1;
                                }
                                // 2.2) Verificamos si es internal
                                if (cmpResults.true === linkTokkens.length) {
                                    internal = true;
                                }
                            }
                        }
                    }
                }
            });
        }
    }
    return false;
};
/**
 * @name NextLink
 * @description atomic component
 * @see {@link https://nextjs.org/docs/api-reference/next/link}
 * @param {LinkProps} props
 * @param {React.Ref} ref
 * @returns {React.FC}
 */
const NextLink = ({ id, children, className, href, taggingInfo, title, target, forceExternal, ariaLabel, screenReadable, hideAccesible, onClick, buttonTypeHtml, nextLinkProps, disabled, cyData, custoObjectInfo, }) => {
    let currentClassName = `next-link${className ? ` ${className}` : ''}`;
    // personalizo
    let editModal = null;
    if (custoObjectInfo) {
        editModal = () => {
            custoObjectInfo.handler(custoObjectInfo.entryPoint);
        };
        currentClassName = `${currentClassName} custo-editable`;
        if (children) {
            return (react_1.default.createElement("div", { className: currentClassName, onClick: editModal }, children));
        }
        return (react_1.default.createElement("div", { className: currentClassName, onClick: editModal }, "Enlace"));
    }
    // 0) vemos si tiene href sino tiene solo es un elemento para taggear (TODO)
    if (!href) {
        return (react_1.default.createElement(next_components_tag_link_1.default, { id: id || null, taggingInfo: taggingInfo, href: href, className: currentClassName, title: title, target: target, ariaLabel: ariaLabel, screenReadable: screenReadable, hideAccesible: hideAccesible, onClick: onClick, buttonTypeHtml: buttonTypeHtml, disabled: disabled, cyData: cyData }, children));
    }
    let insideAppLink = checkIfHrefCouldBeInternal(href, forceExternal);
    // 1) Comprobación para webview
    if (!insideAppLink && !forceExternal && process.env.NEXT_PUBLIC_WEB_VIEW === 'true') {
        return null;
    }
    // si se ha hecho forceExternal le concateno el https://www.movistar.es si no lo tiene
    // "2 ) logica de link as usual"
    if (currentEnv === 'dev' && !forceExternal) {
        href = getReadyLinkForDev(href);
    }
    if (currentEnv !== 'dev' && forceExternal) {
        href = appendHost(href);
    }
    if (!insideAppLink) {
        return (react_1.default.createElement(next_components_tag_link_1.default, { id: id || null, taggingInfo: taggingInfo, href: href, className: currentClassName, title: title, target: target, ariaLabel: ariaLabel, screenReadable: screenReadable, hideAccesible: hideAccesible, onClick: onClick, disabled: disabled, cyData: cyData }, children));
    }
    /* Para enlaces en relativo que se consideren internos  a la app */
    const { as, prefetch, replace, scroll, shallow, locale } = nextLinkProps;
    return (react_1.default.createElement(link_1.default, { href: href, as: as, passHref: true, prefetch: prefetch, replace: replace, scroll: scroll, shallow: shallow, locale: locale },
        react_1.default.createElement(next_components_tag_link_1.default, { id: id || null, taggingInfo: taggingInfo, href: href, target: target, className: currentClassName, onClick: editModal ? editModal : onClick, title: title, ariaLabel: ariaLabel, cyData: cyData, screenReadable: screenReadable, hideAccesible: hideAccesible, disabled: disabled }, children)));
};
NextLink.propTypes = {
    id: prop_types_1.default.string,
    className: prop_types_1.default.string,
    taggingInfo: prop_types_1.default.object.isRequired,
    target: prop_types_1.default.string,
    title: prop_types_1.default.string,
    ariaLabel: prop_types_1.default.string,
    disabled: prop_types_1.default.bool,
    screenReadable: prop_types_1.default.bool,
    nextLinkProps: prop_types_1.default.shape({
        passHref: prop_types_1.default.bool,
        replace: prop_types_1.default.bool,
        as: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object]),
        prefetch: prop_types_1.default.bool,
        scroll: prop_types_1.default.bool,
        shallow: prop_types_1.default.bool,
        locale: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.bool]),
    }),
    href: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.object]),
    forceExternal: prop_types_1.default.bool,
    cyData: prop_types_1.default.string,
    onClick: prop_types_1.default.func,
    buttonTypeHtml: prop_types_1.default.string,
};
NextLink.defaultProps = {
    id: null,
    className: '',
    target: '_self',
    screenReadable: true,
    forceExternal: false,
    nextLinkProps: {
        passHref: true,
        as: null,
        prefetch: true,
        replace: false,
        scroll: true,
        shallow: true,
        locale: '',
    },
    disabled: false,
    onClick: null,
    buttonTypeHtml: 'button',
};
exports.default = NextLink;
//# sourceMappingURL=index.js.map